import { useRouter } from "../components/atoms/DependencyHelper";
import labels from "../config/labels";
import { getSessionStorage } from "../utils/helperServices";

export const breadcrumbGenerator=(customBreadcrumb)=>{
  let productlistfilter =
    typeof window !== "undefined" &&
    getSessionStorage(labels?.Session_Keys?.lbl_list_page_router_with_filters)
      ? getSessionStorage(
      labels?.Session_Keys?.lbl_list_page_router_with_filters
      )[0]?.products
      : "/shopping/products";
  let dealfilter = typeof window !== "undefined" && getSessionStorage("deals") ?getSessionStorage("deals") :"/shopping/deals";
  const router = useRouter();
  let breadcrumbconfig={
    productlist:[
      { link: "/", label: labels.BreadCrumbLabels.lbl_home },
      {
        link: "/shopping/products",
        label: labels.BreadCrumbLabels.lbl_browse_products,
      },
    ],
    cmsPage:[
      { link: "/", label: labels.BreadCrumbLabels.lbl_home },
      {
        link: customBreadcrumb?.link,
        label: customBreadcrumb?.label,
      },
    ],
    productdetails:[
      { link: "/", label: labels.BreadCrumbLabels.lbl_home },
      {
        link: productlistfilter,
        label: labels.BreadCrumbLabels.lbl_browse_products,
      },
      {
        link: "/shopping/product-details/[id]",
        label: labels.BreadCrumbLabels.lbl_product_details,
      },
    ],
    productcompare:[{ link: "/", label: labels.BreadCrumbLabels.lbl_home },
      {
        link: productlistfilter,
        label: labels.BreadCrumbLabels.lbl_browse_products,
      },
      {
        link: "/shopping/product-compare",
        label: labels.BreadCrumbLabels.lbl_compare_products,
      },],
    deals:[{ link: "/", label: labels.BreadCrumbLabels.lbl_home },
      {
        link: dealfilter,
        label: labels.BreadCrumbLabels.lbl_browse_all_deals
      },
    ],
    dealdetails:[{ link: "/", label: labels.BreadCrumbLabels.lbl_home },{
      link: dealfilter,
      label: labels.BreadCrumbLabels.lbl_browse_all_deals
    },
      {
        link: "/shopping/deal-details-page/[id]",
        label: labels.BreadCrumbLabels.lbl_deal_details
      },],
    dealselection:[
      { link: "/", label: labels.BreadCrumbLabels.lbl_home },
      {
        link: productlistfilter,
        label: labels.BreadCrumbLabels.lbl_browse_products,
      },
      {
        link: `/shopping/product-details/${router.query.id}`,
        label: labels.BreadCrumbLabels.lbl_product_details,
      },
      {
        link: "/shopping/deal-selection",
        label: labels.lbl_select_deal
      },
    ],
    orderhistory:[
      { link: "/", label: labels.BreadCrumbLabels.lbl_home },
      {
        link: "/shopping/view-order-history",
        label: labels.BreadCrumbLabels.lbl_order_history
      },
    ],
    orderdetails:[
      { link: "/", label: labels.BreadCrumbLabels.lbl_home },
      {
        link: "/shopping/view-order-history",
        label: labels.BreadCrumbLabels.lbl_order_history
      },
      {
        link: "/shopping/view-order-details",
        label: labels.BreadCrumbLabels.lbl_order_details
      },
    ],
    trackorder:[
      { link: "/", label: labels.BreadCrumbLabels.lbl_home },
      {
        link: "/shopping/view-order-history",
        label: labels.BreadCrumbLabels.lbl_order_history
      },
      {
        link: "/shopping/track-my-order",
        label: labels.BreadCrumbLabels.lbl_track_order
      },
    ],
    upgradePage:[
      { link: "/", label: labels.BreadCrumbLabels.lbl_home },
      {
        link:"/shopping/upgrade",
        label:labels.BreadCrumbLabels.lbl_upgrade_page
      }
    ]
  }
  return breadcrumbconfig
}
